import { css } from 'aphrodite';
import * as React from 'react';
import { getInstagramProfileUrl } from '../../../../models/utils/socialUtils';
import { styleSheet } from './styles';

export const INSTAGRAM_HANDLES_WARNING = 'Confirm each Instagram handle tags the right account.';

interface IProps {
	handles: string[];
}

export const InstagramHandlesWarning: React.FC<IProps> = ({ handles }) => {
	if (!handles.length) {
		return null;
	}

	return (
		<div className={css(styleSheet.handlesNotice)}>
			<span>{INSTAGRAM_HANDLES_WARNING}</span>
			<div className={css(styleSheet.handlesNoticeLinks)}>
				{handles.map(handle => (
					<a
						className={css(styleSheet.handlesNoticeLink)}
						href={getInstagramProfileUrl(handle)}
						key={handle}
						rel='noopener noreferrer'
						target='_blank'
					>
						@{handle}
					</a>
				))}
			</div>
		</div>
	);
};
